import React from 'react';
import {
  appStoreUrlArticleBodyCta,
  appStoreUrlArticleMidCta,
  googlePlayUrlArticleBodyCta,
  googlePlayUrlArticleMidCta,
} from '@/utils/appStoreUtm';

export type AppDownloadButtonsPlacement = 'article_body' | 'article_mid';

interface AppDownloadButtonsProps {
  /** 記事ID（UTM の utm_id と同一値） */
  articleId: string | number;
  /** 本文末尾 CTA と中盤マーカー CTA で UTM を分ける */
  placement?: AppDownloadButtonsPlacement;
}

/**
 * コラム記事などでアプリストアへ誘導するブロック（公開ページ用）
 */
export default function AppDownloadButtons({
  articleId,
  placement = 'article_body',
}: AppDownloadButtonsProps) {
  const appStoreUrl =
    placement === 'article_mid'
      ? appStoreUrlArticleMidCta(articleId)
      : appStoreUrlArticleBodyCta(articleId);
  const googlePlayUrl =
    placement === 'article_mid'
      ? googlePlayUrlArticleMidCta(articleId)
      : googlePlayUrlArticleBodyCta(articleId);

  return (
    <div
      className="my-8 sm:my-10 rounded-xl border border-gray-200 bg-gradient-to-br from-[#F0FDFF] to-[#F8FAFC] p-5 sm:p-6"
      data-app-download-placement={placement}
    >
      <p className="text-sm font-semibold text-gray-900 mb-1">あなたの旅の栞づくりをサポート</p>
      <p className="text-xs sm:text-sm text-gray-600 mb-4">
        Social Trip は無料アプリ。AIで旅行プランを組み立て、旅の栞としてまとめたり共有したりできます。
      </p>
      <div className="flex flex-col sm:flex-row flex-wrap gap-3">
        <a
          href={appStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center rounded-lg bg-black text-white text-sm font-medium px-4 py-3 min-h-[44px] hover:opacity-90 transition-opacity"
        >
          App Store でダウンロード
        </a>
        <a
          href={googlePlayUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white text-gray-900 text-sm font-medium px-4 py-3 min-h-[44px] hover:bg-gray-50 transition-colors"
        >
          Google Play でダウンロード
        </a>
      </div>
    </div>
  );
}
